exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "admin-home .spacer {\n  margin-top: 10px; }\n\nadmin-home .radio-chkbox-spacer {\n  margin: 0px 10px; }\n\nadmin-home h2, admin-home .ui-widget-header {\n  text-align: center;\n  margin: 5px 0px 10px 0px; }\n\nadmin-home h3 {\n  margin: 8px 0px 15px 0px;\n  text-decoration: underline; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/bs_work/toMigrate_litePortal/src/app/admin-module/admin-home/admin-home.component.scss
// module id = ../../../../../src/app/admin-module/admin-home/admin-home.component.scss
// module chunks = main